<template>
  <v-dialog persistent v-model="dialog" scrollable @keydown.esc="dialog = false" width="850" scrollable>
    <LuSessionForm 
      ref="luSessionForm" 
      :dialog.sync="dialog" 
      @refresh="$emit('refresh')" 
      @itemAdded="$emit('itemAdded', $event)">
    </LuSessionForm>
  </v-dialog>
</template>
<script>
  import LuSessionForm from '@components/form/add-edit/LuSessionForm'
export default {
  components: {
    LuSessionForm,
  },
  data: () => ({
    dialog: false,
  }),
  created() {},
  computed: {
  },
  methods: {
    editLuSession(entry) {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.luSessionForm.editLuSession(entry)
      })
    },
    addLuSession() {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.luSessionForm.addLuSession()
      })
    },
  },
  } 
  
</script>
<style>

</style>